import script from "./ZonesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ZonesTable.vue?vue&type=script&setup=true&lang=js"

import "./ZonesTable.vue?vue&type=style&index=0&id=6040952a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6040952a"]])

export default __exports__